__turbopack_context__.v({
  "axisHead": "variant-selector-module-scss-module__6oHeQq__axisHead",
  "axisName": "variant-selector-module-scss-module__6oHeQq__axisName",
  "axisValue": "variant-selector-module-scss-module__6oHeQq__axisValue",
  "isConflict": "variant-selector-module-scss-module__6oHeQq__isConflict",
  "isDisabled": "variant-selector-module-scss-module__6oHeQq__isDisabled",
  "isSelected": "variant-selector-module-scss-module__6oHeQq__isSelected",
  "pill": "variant-selector-module-scss-module__6oHeQq__pill",
  "selector": "variant-selector-module-scss-module__6oHeQq__selector",
  "swatch": "variant-selector-module-scss-module__6oHeQq__swatch",
  "swatchFill": "variant-selector-module-scss-module__6oHeQq__swatchFill",
  "thumb": "variant-selector-module-scss-module__6oHeQq__thumb",
  "thumbImg": "variant-selector-module-scss-module__6oHeQq__thumbImg",
  "thumbName": "variant-selector-module-scss-module__6oHeQq__thumbName",
  "values": "variant-selector-module-scss-module__6oHeQq__values",
  "valuesImage": "variant-selector-module-scss-module__6oHeQq__valuesImage",
});
